<div class="flex-content">
  <div class="content col-sm container-fluid">
    <div class="row content-row no-gutters">

      <div class="list-box col-sm-12">
        <h2 class="list-title col-sm-12">PEOPLE</h2>
        <!-- card container-->
        <div (click)='routing("person", person.id)' 
            *ngFor="let person of result_people" 
            class="people-box col-sm-12 col-md-6 col-lg-4">

          <div class="people-desc">
            <div class="people-img">
              <div class="people-img-box">
                <img default="./../../../../assets/Contents/imgs/default_person.png" [srcset]=" imgPath + person.img" [src]=" imgPath + person.img">
              </div>
            </div>

            <h5 class="name">{{person.name}}</h5>
            <p class="menu02">
              {{person.topics}} 
            </p>
            <sub class="menu01">{{person.status}}</sub>
          </div>
        </div>
      </div>

      <div class="list-box col-sm-12">
        <h2 class="list-title col-sm-12">PUBLICATIONS</h2>

        <!-- <a [routerLink]='["main/international/individual/" , result_publications.id]' target="_blank" 
        *ngFor="let publication of result_publications" class="object-box col-sm-12 col-md-6 col-lg-6 col-xl-2"> -->

        <div (click)='routing("publications", publication.id, publication.type)'
        *ngFor="let publication of result_publications"
        class="object-box col-sm-12 col-md-6 col-lg-6 col-lg-6 col-xl-2"
        >
          
          <div class="object-desc">
            <h5>{{publication.title}}</h5>
            <p class="menu02">{{publication.year}}</p>
          </div>

        </div>
        <!-- </a> -->
      </div>


      <div class="list-box col-sm-12">
        <h2 class="list-title col-sm-12">PROJECTS</h2>
        <div (click)='routing("projects", project.id)' 
        *ngFor="let project of result_projects" class="object-box col-sm-12 col-md-6 col-lg-6 col-xl-2">
          <div class="object-desc">
            <h5>{{project.name}}</h5>
            <p class="menu02">{{project.year}}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/search-result/search-result.component.html